module.exports = __webpack_public_path__ + "img/logo.d36053fa.svg";